import { format, unwrapFunctionStore } from 'svelte-i18n';

import { typeCharacters } from '@client/utils/dom';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const integrationForm = {
  element: '.modal-content',
  popover: {
    title: 'Configuring an Integration',
    description:
      'Provide the necessary details for your integration, including a unique name, any required parameters, and a fallback text. Once done, click <strong>&quot;Create Integration&quot;</strong> to save your plugin configuration.',
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const back = document.querySelector('.back');

      if (back) {
        back.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 200);
      }
    }
  }
};

export const rulename = {
  element: '#form-modal > div.modal-body > div:nth-child(1)',
  popover: {
    title: 'Name',
    description:
      'This unique name is used inside your signature templates to control what and where this plugin runs.<br><br>For example, if you name your plugin <strong>&quot;tour_name&quot;</strong>, you can use <strong>&quot;[[plugin:tour_name]]&quot;</strong> tag in your signature template to display the plugin output.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const rulenameInput = document.querySelector('#form-modal > div.modal-body > div:nth-child(1) > input');

      if (rulenameInput && rulenameInput.value === '') {
        typeCharacters(rulenameInput, 'tour_name', 75);
      }
    }
  }
};

export const parameters = {
  element: '#form-modal > div.modal-body > div:nth-child(2)',
  popover: {
    title: 'Parameters',
    description:
      'Click the <strong>&quot;<i class="os-icon-plus"></i> Parameter&quot;</strong> button to add a new parameter field to your plugin. This is an easy way to configure how this plugin will interact with the service.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const addParamBtn = document.querySelector('.os-icon-plus');
      const nameField = document.querySelector(
        '#form-modal > div.modal-body > div:nth-child(2) > div.parameters.framed > div > input.name'
      );
      const navBtns = document.querySelectorAll('footer > span.driver-popover-navigation-btns');

      if (addParamBtn && (nameField?.value === '' || !nameField) && navBtns) {
        navBtns[0].children[0].disabled = true;
        navBtns[0].children[0].classList.add('driver-popover-btn-disabled');
        navBtns[0].children[1].disabled = true;
        navBtns[0].children[1].classList.add('driver-popover-btn-disabled');

        addParamBtn.click();
      }

      setTimeout(() => {
        const nameField = document.querySelector(
          '#form-modal > div.modal-body > div:nth-child(2) > div.parameters.framed > div > input.name'
        );

        if (nameField && nameField.value === '') {
          typeCharacters(nameField, 'tour_params', 75);
        }
      }, 1000);

      setTimeout(() => {
        const valueField = document.querySelector(
          '#form-modal > div.modal-body > div:nth-child(2) > div.parameters.framed > div > input.value'
        );

        if (valueField && valueField.value === '') {
          typeCharacters(valueField, 'Hello from team Opensense!', 75);
        }
      }, 2000);

      setTimeout(() => {
        navBtns[0].children[0].disabled = false;
        navBtns[0].children[0].classList.remove('driver-popover-btn-disabled');
        navBtns[0].children[1].disabled = false;
        navBtns[0].children[1].classList.remove('driver-popover-btn-disabled');
      }, 4025);
    },
    onPrevClick: () => {
      const removeParamBtn = document.querySelector('.os-icon-trash');

      if (removeParamBtn) {
        removeParamBtn.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 50);
      }
    }
  }
};

export const paramsHideField = {
  element: '#form-modal > div.modal-body > div:nth-child(2) > div.parameters.framed > div',
  popover: {
    title: 'Hiding a Parameter Value',
    description:
      "You can easily hide or reveal sensitive values by clicking the <code><i class='os-icon-eye'></i></code> icon. This helps protect confidential information while managing your integration.",
    side: 'top',
    align: 'center',
    onPopoverRender: () => {
      const eyeIcon = document.querySelector('#param-value-0-hide');

      if (eyeIcon && !eyeIcon.classList.contains('os-icon-eye-off')) {
        setTimeout(() => {
          eyeIcon.click();
        }, 500);

        setTimeout(() => {
          eyeIcon.click();
        }, 1000);

        setTimeout(() => {
          eyeIcon.click();
        }, 1500);
      }
    },
    onPrevClick: () => {
      const eyeIcon = document.querySelector('#param-value-0-hide');

      if (eyeIcon) {
        eyeIcon.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 50);
      }
    }
  }
};

export const paramsRemoveField = {
  element: '#form-modal > div.modal-body > div:nth-child(2) > div.parameters.framed > div > i.os-icon-trash.pointer',
  popover: {
    title: 'Removing a Parameter',
    description: 'Click the <code><i class="os-icon-trash"></i></code> icon to remove a parameter from your plugin.',
    side: 'top',
    align: 'center'
  }
};

export const fallbackText = {
  element: '#form-modal > div.modal-body > div:nth-child(3)',
  popover: {
    title: 'Fallback Text',
    description:
      'This is the fallback text displayed if the plugin fails to run. You can display a message, insert ad or asset rulenames, or keep it empty.',
    side: 'right',
    align: 'center'
  }
};
